import { authService } from "../../services";

const useDecodedToken = () => {
  const decodeToken = authService.getDecodedToken();
  const { sourceId, username, source } = decodeToken;
  return { sourceId, connectedUsername: username, role: source };
};

export default useDecodedToken;
